export default "<div class=\"loader-body\" *ngIf=\"loading\">\n  <div class=\"loading\">Loading</div>\n</div>\n<router-outlet></router-outlet>\n"